import React from 'react';
import Icon from '../../../components/AppIcon';

const SystemHealthMetrics = ({ systemHealth }) => {
  const healthMetrics = [
    {
      label: 'System Status',
      value: systemHealth?.status,
      icon: 'Activity',
      color: 'green',
      displayValue: systemHealth?.status?.charAt(0)?.toUpperCase() + systemHealth?.status?.slice(1)
    },
    {
      label: 'Uptime',
      value: `${systemHealth?.uptime}%`,
      icon: 'TrendingUp',
      color: 'blue'
    },
    {
      label: 'Active Users',
      value: systemHealth?.activeUsers?.toLocaleString(),
      icon: 'Users',
      color: 'purple'
    },
    {
      label: 'Admin Sessions',
      value: systemHealth?.activeSessions,
      icon: 'Shield',
      color: 'amber'
    },
    {
      label: 'Last Incident',
      value: systemHealth?.lastIncident,
      icon: 'AlertCircle',
      color: 'green'
    }
  ];

  const colorClasses = {
    green: 'bg-green-50 border-green-200 text-green-700',
    blue: 'bg-blue-50 border-blue-200 text-blue-700',
    purple: 'bg-purple-50 border-purple-200 text-purple-700',
    amber: 'bg-amber-50 border-amber-200 text-amber-700'
  };

  const iconColorClasses = {
    green: 'bg-green-100 text-green-600',
    blue: 'bg-blue-100 text-blue-600',
    purple: 'bg-purple-100 text-purple-600',
    amber: 'bg-amber-100 text-amber-600'
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2">
            <Icon name="Activity" className="w-5 h-5 text-primary" />
            System Health Metrics
          </h2>
          <p className="text-gray-600 text-sm mt-1">Real-time platform performance and availability</p>
        </div>
        <div className="flex items-center gap-2 px-3 py-1.5 bg-green-50 border border-green-200 rounded-full">
          <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
          <span className="text-sm font-medium text-green-700">All Systems Operational</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {healthMetrics?.map((metric, index) => (
          <div
            key={index}
            className={`${colorClasses?.[metric?.color]} border rounded-lg p-4 transition-all hover:shadow-md`}
          >
            <div className={`w-10 h-10 ${iconColorClasses?.[metric?.color]} rounded-lg flex items-center justify-center mb-3`}>
              <Icon name={metric?.icon} className="w-5 h-5" />
            </div>
            <div className="text-sm font-medium mb-1 opacity-75">{metric?.label}</div>
            <div className="text-xl font-bold">{metric?.displayValue || metric?.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SystemHealthMetrics;